import React, { lazy } from 'react';
type Product = {
  title: string;
  url: string;
  image: string;
};
const products: Product[] = [{
  title: 'GNLD Pro Vitality',
  url: 'https://www.bestvitaminsforall.com/m8/3140S--gnld-neolife-pro-vitality-plus-pack.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3140S.jpg'
}, {
  title: 'GNLD Salmon Oil Plus',
  url: 'https://www.bestvitaminsforall.com/m8/3502S--neolife-omega-3-salmon-oil-plus.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3502S.jpg'
}, {
  title: 'GNLD Tre En En',
  url: 'https://www.bestvitaminsforall.com/m8/3130S--gnld-neolife-tre-en-en.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3130S.jpg'
}, {
  title: 'GNLD Lipotropic Adjunct',
  url: 'https://www.bestvitaminsforall.com/m8/3510S--gnld-neolife-lipotropic-adjunct.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3510S.jpg'
}, {
  title: 'GNLD Phytodefense',
  url: 'https://www.bestvitaminsforall.com/m8/3309S--gnld-neolife-phytodefense.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3309S.jpg'
}, {
  title: 'GNLD Vitamin E',
  url: 'https://www.bestvitaminsforall.com/m8/3340S--gnld-neolife-vitamin-e-plus-water-miscible.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3340S.jpg'
}, {
  title: 'GNLD Tre',
  url: 'https://www.bestvitaminsforall.com/m8/3010S--gnld-neolife-tr-tre.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3010S.jpg'
}, {
  title: 'GNLD Carotenoid Complex',
  url: 'https://www.bestvitaminsforall.com/m8/3300S--gnld-neolife-daily-carotenoid-complex.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3300S.jpg'
}, {
  title: 'GNLD Active 40 Plus',
  url: 'https://www.bestvitaminsforall.com/m8/3115S.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3115S.jpg'
}, {
  title: 'GNLD Cal Mag',
  url: 'https://www.bestvitaminsforall.com/m8/3402S--chelated-cal-mag-with-vitamin-d-capsules.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3402S.jpg'
}, {
  title: 'GNLD Masculine Herbal Complex',
  url: 'https://www.bestvitaminsforall.com/m8/3625S--masculine-herbal-complex.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3625S.jpg'
}, {
  title: 'GNLD Feminine Herbal Complex',
  url: 'https://www.bestvitaminsforall.com/m8/3615S--feminine-herbal-complex.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3615S.jpg'
}, {
  title: 'GNLD Formula IV Plus',
  url: 'https://www.bestvitaminsforall.com/m8/3105S--gnld-neolife-formula-iv-plus.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3105S.jpg'
}, {
  title: 'GNLD Garlic Allium',
  url: 'https://www.bestvitaminsforall.com/m8/3665S--garlic-allium-complex.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3665S.jpg'
}, {
  title: 'GNLD Full Motion',
  url: 'https://www.bestvitaminsforall.com/m8/3505S--neolife-glucosamine-full-motion.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3505S.jpg'
}, {
  title: 'GNLD Enzyme Digestive Aid',
  url: 'https://www.bestvitaminsforall.com/m8/3520S--enzyme-digestive-aid.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3520S.jpg'
}, {
  title: 'GNLD Betagard',
  url: 'https://www.bestvitaminsforall.com/m8/3530S--gnld-neolife-betagard.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3530S.jpg'
}, {
  title: 'GNLD Aloe Vera Plus Juice',
  url: 'https://www.bestvitaminsforall.com/m8/3000S--aloe-vera-plus-best-aloe-vera-juice.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3000S.jpg'
}, {
  title: 'GNLD All C Vitamin C',
  url: 'https://www.bestvitaminsforall.com/m8/3332S--all-c-chewable-250-tablets-vitamin-c.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3332S.jpg'
}, {
  title: 'GNLD Stress 30',
  url: 'https://www.bestvitaminsforall.com/m8/3113S.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3113S.jpg'
}, {
  title: 'GNLD Zinc',
  url: 'https://www.bestvitaminsforall.com/m8/3425S--chelated-zinc.html',
  image: 'https://www.bestvitaminsforall.com/images/products/3425S.jpg'
}, {
  title: 'Multipure CB5 Filters',
  url: 'https://www.bestvitaminsforall.com/m8/34S%28cl%29--multipure-cb5-water-filter-under-counter-counter-top-also-fits-gnld-neolife-filter-system-only-a-few-left.html',
  image: 'https://www.bestvitaminsforall.com/images/products/34S.jpg'
}, {
  title: 'GNLD Distributors',
  url: 'https://www.bestvitaminsforall.com/21.html',
  image: 'https://www.bestvitaminsforall.com/images/products/distributor.jpg'
}, {
  title: 'GNLD Distributors',
  url: 'https://www.bestvitaminsforall.com/21.html',
  image: 'https://www.bestvitaminsforall.com/images/products/distributor.jpg'
}];
// Fallback placeholder for images that fail to load
const FALLBACK_IMAGE = 'https://via.placeholder.com/200x200/f8fafc/94a3b8?text=GNLD';
export function PopularProducts() {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = FALLBACK_IMAGE;
  };
  return <section className="bg-white py-12 lg:py-16" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="flex items-center gap-4 mb-8" data-id="element-113">
          <h2 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-114">
            Popular GNLD Products
          </h2>
          <div className="h-0.5 bg-[#0e7be1] flex-grow max-w-[80px]" data-id="element-115"></div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 lg:gap-4" data-id="element-116">
          {products.map((product, index) => <a key={`${product.title}-${index}`} href={product.url} className="block bg-white border border-gray-100 rounded-lg overflow-hidden" data-id="element-117">
              <div className="aspect-square w-full bg-gray-50 p-3" data-id="element-118">
                <img src={product.image} alt={product.title} onError={handleImageError} className="w-full h-full object-contain" loading="lazy" data-id="element-119" />
              </div>
              <div className="p-3" data-id="element-120">
                <h3 className="text-xs lg:text-sm font-medium text-gray-800 line-clamp-2 leading-snug min-h-[2.25rem]" data-id="element-121">
                  {product.title}
                </h3>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}